(function () {
    'use strict';

    angular.module("imApp").factory("p2ImportProcService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 878,
                    parameters: parms || {}
                });
            },
            listEncodingTypes: function (parms) {
                return $ihttp.post({
                    method: 886,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 879,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
